angular.module('aprima-bridge').factory('WebBridge',
    ['$rootScope', '$log',
        function ($rootScope, $log) {
            'use strict';
            
            var getLog = function() {
                return $log.delegate || $log;    
            };
            
            var _updateSettings = function (settings) {
                getLog().info('calling web bridge: settings = ' + JSON.stringify(settings));
            };

            var _modalAlert = function (alert) {
                getLog().error('WebBridge.createModalAlert  ----------');
                getLog().error('alert.title  = ' + alert.title);
                getLog().error('alert.message = ' + alert.message);
            };

            return {
                onNavigate: angular.noop,
                changeUserInfo: angular.noop,
                setupPage: angular.noop,
                setHeaderMode: angular.noop,
                goBack: angular.noop,
                pageFinished: angular.noop,
                pickMedia: angular.noop,
                updateSettings: _updateSettings,
                createModalAlert: _modalAlert,
                closeSearchHeader: angular.noop,
                updateBadges: angular.noop,
                updatePageIndicator: angular.noop,
                overriddenMessages: angular.noop,
                debugModeToggled: angular.noop,
                updateInactivityTimeout: angular.noop,
                scanBarcode: angular.noop,

                on: function (event, $scope, fn) {
                    //handles events received from the getBridge() and removes the event when the scope is destroyed
                    var handlerForScope = function (e, args) {

                        function handler () {
                            fn(args);
                        }

                        if($scope && $scope.$evalAsync) {
                            $scope.$evalAsync(function() {
                                handler();
                            });
                        }
                        else {
                            handler();
                        }
                    };

                    var removerEventListener = $rootScope.$on(event, handlerForScope);

                    if($scope){
                        $scope.$on('$destroy', function () {
                            getLog().info('removing listener from bridge due to $scope.$destroy event');
                            removerEventListener();
                            $scope = fn = null;
                        });
                    }

                    return removerEventListener;
                },
                //only for the webbridge
                fireEvent: function (event, data) {
                    $rootScope.$broadcast(event, data);                   
                }                
            };
        }]);
